const defaultState = {
    success: false,
    loading: false,
    error: null
}

const ON_RESET_ACCEPT_INVITATION_FORM = 'ON_RESET_ACCEPT_INVITATION_FORM';

const ON_ACCEPT_INVITATION_REQUEST = 'ON_ACCEPT_INVITATION_REQUEST';
const ON_ACCEPT_INVITATION_FAILURE = 'ON_ACCEPT_INVITATION_FAILURE';
const ON_INVITATION_ACCEPTED = 'ON_INVITATION_ACCEPTED';

export const acceptInvitationReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ON_RESET_ACCEPT_INVITATION_FORM:
            return {...state, ...defaultState}

        case ON_ACCEPT_INVITATION_REQUEST:
            return {...state, success: false, loading: true, error: null}
        case ON_ACCEPT_INVITATION_FAILURE:
            return {...state, success: false, loading: false, error: action.payload }
        case ON_INVITATION_ACCEPTED:
            return {...state, success: true, loading: false, error: null}
        default:
            return state
    }
}

export const onResetAcceptInvitationForm = (payload) => ({ type: ON_RESET_ACCEPT_INVITATION_FORM, payload });

export const onAcceptInvitationRequest = (payload) => ({type:ON_ACCEPT_INVITATION_REQUEST, payload})
export const onAcceptInvitationFailure = (payload) => ({type:ON_ACCEPT_INVITATION_FAILURE, payload})
export const onInvitationAccepted= (payload) => ({type:ON_INVITATION_ACCEPTED, payload})